import React, { useState } from 'react';
import { Confirm, useRefresh, useNotify, useRecordContext } from 'react-admin';
import RefreshIcon from '@mui/icons-material/Refresh';

import IconButton from '../../common/buttons/IconButton';

import { cloneInvoice } from '../../../services/api';


const CloneInvoiceButton = () => {
    const record = useRecordContext();
    const refresh = useRefresh();
    const notify = useNotify();
    const [showDialog, setShowDialog] = useState(false);

    const handleConfirm = async () => {
        const response = await cloneInvoice(record.id);
        if (response.id) {
            refresh();
            notify('Invoice cloned');
        }

        handleClose();
    };

    const handleOpen = () => {
        setShowDialog(true);
    };

    const handleClose = () => {
        setShowDialog(false);
    };

    if (!record) {
        return null;
    }

    return (
        <>
            <IconButton icon={<RefreshIcon />} onClick={handleOpen}>Clone</IconButton>
            <Confirm
                isOpen={showDialog}
                title={`Clone invoice or credit #${record.id}`}
                content={`Are you sure you want to clone this document ?`}
                onConfirm={handleConfirm}
                onClose={handleClose}
            />
        </>
    );
};

export default CloneInvoiceButton;
